export let CrumbType = /*#__PURE__*/function (CrumbType) {
  CrumbType["crumb"] = "crumb";
  CrumbType["crumbPile"] = "crumbPile";
  return CrumbType;
}({});
export let PilePlacement = /*#__PURE__*/function (PilePlacement) {
  PilePlacement["beginning"] = "beginning";
  PilePlacement["middle"] = "middle";
  return PilePlacement;
}({});
export const DEFAULT_PILE_AFTER_COUNT = 5;
//# sourceMappingURL=consts.js.map